<template>
  <div>
    <!-- <v-btn @click="openpopup" color="blue" dark>test</v-btn>
    <v-btn @click="testpopup2" color="red" dark>test</v-btn>
    {{isPcfacebook}}-->
    <v-dialog v-model="showMap" persistent fullscreen>
      <v-card>
        <v-card-text style="height: 100%" class="pa-0">
          <div
            id="map_clickable"
            ref="map_clickable"
            style="overflow: auto; width: 100%; height: calc(100vh)"
          ></div>
          <div class="pa-2" style="position: fixed; left: 0; right: 0; top: 0">
            <v-layout>
              <v-flex>
                <v-text-field
                  solo
                  v-model="searchPlace"
                  hide-details
                  @blur="onBlur"
                  @keyup.enter="onBlur"
                  id="pac-input"
                  type="text"
                  placeholder="ค้นหาสถานที่"
                ></v-text-field>
              </v-flex>
              <v-flex shrink>
                <v-btn color="primary" @click="onBlur">{{
                  $t('Search')
                }}</v-btn>
              </v-flex>
              <v-flex shrink>
                <v-btn fab small @click="setCurrent" @hover="setCurrent">
                  <v-icon>mdi-crosshairs-gps</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
          <div style="position: fixed; bottom: 0px; left: 0; right: 0">
            <div
              class="text-xs-center ma-auto pa-3"
              style="
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
                background-color: white;
              "
            >
              <div class="title primary--text mb-1">
                {{ $t('Select delivery location') }}
              </div>
              <v-btn
                class="mt-2"
                color="primary"
                block
                @click="confrimAddress"
                >{{ $t('confirm') }}</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div
      style="height: 350px; position: relative"
      :style="{ border: error ? 'solid red 1.2px' : 'solid black 1.2px' }"
    >
      <div id="preview_map" ref="preview_map" style="height: 100%"></div>

      <div class="addressinfo" style="bottom: 65%">
        <v-btn color="primary" block @click="showMap = true">{{
          $t('Search an address on map')
        }}</v-btn>
      </div>
    </div>
    <div
      class="pa-2"
      style="
        border-left: 1px solid #3e3e3e;
        border-right: 1px solid #3e3e3e;
        border-bottom: 1px solid #3e3e3e;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      "
    >
      <div v-if="infoloading" class="text-xs-center">
        <v-progress-circular size="18" indeterminate></v-progress-circular>
      </div>
      <template v-else-if="placesinfo">
        <v-layout>
          <v-flex pt-2><v-icon x-large>place</v-icon></v-flex>
          <v-flex class="pa-2">
            <div v-html="placesinfo"></div>
          </v-flex>
        </v-layout>
      </template>
      <template v-else>
        <v-alert :value="true" type="info">
          {{
            $t(
              'If the map does not display. Please re-check to allow access to your location or refresh this page again.'
            )
          }}
        </v-alert>
      </template>
    </div>

    <v-dialog v-model="showSuggestList" max-width="1000" scrollable>
      <v-card>
        <div class="text-xs-right">
          <v-btn flat fab small>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text style="height: 600px">
          <v-list two-line>
            <template v-for="(suggest, index) in placelist">
              <v-list-tile
                :key="'list_' + index + suggest.name"
                avatar
                @click="onSelectSuggest(suggest)"
              >
                <v-list-tile-avatar>
                  <v-icon>mdi-map-marker-outline</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="suggest.name"></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="suggest.geometry.location"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-btn color="primary" small>{{ $t('Select') }}</v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider :key="'divider_' + index"></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
var map
var preview_map
export default {
  components: {},
  props: {
    lastordercoords: {
      type: Object
    },
    error: {
      type: Boolean
    },
    placesinfo: {
      type: String
    },
    shoplocation: {
      default: undefined
    },
    radius: {
      default: 17000
    },
    radiusColor: {
      default: '#FF0000'
    },
    showRadius: {
      default: true
    },
    scrollable: {
      default: true
    },
    shippingType: {
      default: 'map'
    },
    infoloading: {
      default: true
    }
  },
  data() {
    return {
      text: '',
      map: '',
      showMap: false,
      haveGPS: false,
      searchPlace: '',
      autocomplete: null,
      storelocation: {
        lat: 0,
        lng: 0
      },
      newwin: '',
      markerposition: {
        lat: null,
        lng: null
      },
      currentCoords: {
        lat: 0,
        lng: 0
      },
      marker: null,
      directionsService: '',
      directionsRenderer: '',
      preview_marker: null,
      preview_markerposition: {
        lat: null,
        lng: null
      },
      placelist: [],
      showSuggestList: false
    }
  },
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
    isPcfacebook() {
      /* eslint-disable no-useless-escape */

      return (
        !(
          // device detection
          (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
              navigator.userAgent
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              navigator.userAgent.substr(0, 4)
            )
          )
        ) && navigator.userAgent.indexOf('FB') != -1
      )
      /* eslint-enable no-useless-escape */
    }
  },
  async mounted() {
    var vm = this
    try {
      if (
        this.shoplocation &&
        this.shoplocation.length > 0 &&
        this.shoplocation[0].lat_long
      ) {
        let lat_lng = this.shoplocation[0].lat_long.split(',')
        if (lat_lng.length == 2)
          this.storelocation = {
            lat: parseFloat(lat_lng[0]),
            lng: parseFloat(lat_lng[1])
          }
      }

      // if(this.shoplocation && this.shoplocation.length > 0 && this.shoplocation[0].lat && this.shoplocation[0].long){
      //   this.storelocation = {
      //     lat: parseFloat(this.shoplocation[0].lat),
      //     lng: parseFloat(this.shoplocation[0].long),
      //   };
      // }
    } catch (error) {
      //
      // eslint-disable-next-line no-console
      console.log(error)
    }
    if (this.isPcfacebook) {
      vm.openpopup()
    } else {
      var options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }

      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          vm.currentCoords.lat = coords.latitude
          vm.currentCoords.lng = coords.longitude
          vm.haveGPS = true
          vm.initMap()
        },
        (err) => {
          vm.currentCoords.lat = vm.storelocation.lat
          vm.currentCoords.lng = vm.storelocation.lng
          vm.haveGPS = false
          vm.initMap()

          // eslint-disable-next-line no-console
          console.warn(`ERROR(${err.code}): ${err.message}`)
        },
        options
      )
    }
  },
  methods: {
    onSelectSuggest(place) {
      this.showSuggestList = false
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert("No details available for input: '" + place.name + "'")
        return false
      }

      this.setMarkerPosition(place.geometry.location, 'map')
      this.setMarkerPosition(place.geometry.location, 'preview_map')
    },
    onSearchPlace(text) {
      let vm = this
      this.placelist = []
      return new Promise((resolve, reject) => {
        // var input = document.getElementById("pac-input");
        // eslint-disable-next-line no-undef
        vm.autocomplete = new google.maps.places.PlacesService(map)
        // vm.autocomplete = new google.maps.places.Autocomplete(input);
        let request = {
          query: text,
          fields: ['geometry', 'name']
        }
        vm.autocomplete.findPlaceFromQuery(request, function (results, status) {
          // eslint-disable-next-line no-undef
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            if (results.length > 0) {
              let place = results[0]
              vm.placelist = results

              if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                window.alert(
                  "No details available for input: '" + place.name + "'"
                )
                reject()
              }

              vm.setMarkerPosition(place.geometry.location, 'map')
              vm.setMarkerPosition(place.geometry.location, 'preview_map')
              if (results.length > 1) vm.showSuggestList = true

              resolve()
            } else {
              window.alert('No details available')
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    async onBlur() {
      // console.log("onBlur");
      // await this.onSearchPlace(this.searchPlace);
      // this.searchPlace = "";
    },
    openpopup() {
      var vm = this
      this.newwin = window.open(
        window.location.href.replace('transfer', 'getcurrentlocation'),
        'hello',
        'width=1,height=1'
      )
      if (
        !this.newwin ||
        this.newwin.closed ||
        typeof this.newwin.closed == 'undefined'
      ) {
        //POPUP BLOCKED
        vm.currentCoords.lat = vm.storelocation.lat
        vm.currentCoords.lng = vm.storelocation.lng
        vm.initMap()
      } else {
        this.newwin.onbeforeunload = () => {
          var popupcoords = window.document.f1.p_name.value.split(',')
          vm.currentCoords.lat = parseFloat(popupcoords[0])
          vm.currentCoords.lng = parseFloat(popupcoords[1])
          vm.initMap()
        }
      }
    },
    initMap() {
      var vm = this
      if (!(vm.currentCoords.lat && vm.currentCoords.lng)) {
        vm.currentCoords.lat = vm.storelocation.lat
        vm.currentCoords.lng = vm.storelocation.lng
      }

      var latlng = null
      if (vm.lastordercoords) {
        // eslint-disable-next-line no-undef
        latlng = new google.maps.LatLng({
          lat: parseFloat(vm.lastordercoords.lat),
          lng: parseFloat(vm.lastordercoords.lng)
        })
      } else {
        // eslint-disable-next-line no-undef
        latlng = new google.maps.LatLng({
          lat: vm.currentCoords.lat,
          lng: vm.currentCoords.lng
        })
      }
      preview_map = new window.google.maps.Map(
        document.getElementById('preview_map'),
        {
          center: latlng,
          zoom: 15,
          disableDefaultUI: true,
          gestureHandling: 'none',
          zoomControl: false,
          clickableIcons: false,
          keyboardShortcuts: false
        }
      )

      map = new window.google.maps.Map(
        document.getElementById('map_clickable'),
        {
          center: latlng,
          zoom: 15,
          clickableIcons: false,
          zoomControl: true,
          zoomControlOptions: {
            // eslint-disable-next-line no-undef
            position: google.maps.ControlPosition.RIGHT_CENTER
          },
          gestureHandling: 'greedy',
          streetViewControl: false,
          scrollwheel: this.scrollable,
          fullscreenControl: false,
          mapTypeControl: false
        }
      )

      var input = document.getElementById('pac-input')

      // create auto complete when user search place in input
      // eslint-disable-next-line no-undef
      vm.autocomplete = new google.maps.places.Autocomplete(input)
      vm.autocomplete.bindTo('bounds', map)
      vm.autocomplete.setFields([
        'address_components',
        'geometry',
        'icon',
        'name'
      ])
      vm.autocomplete.addListener('place_changed', function () {
        var place = vm.autocomplete.getPlace()
        vm.marker.setPosition(place.geometry.location)
        vm.markerposition.lat = vm.marker.getPosition().lat()
        vm.markerposition.lng = vm.marker.getPosition().lng()
        map.panTo(vm.marker.getPosition())
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          window.alert("No details available for input: '" + place.name + "'")
          return
        }
      })

      map.addListener('center_changed', function () {
        vm.marker.setPosition(map.getCenter())
      })
      preview_map.addListener('center_changed', function () {
        vm.preview_marker.setPosition(preview_map.getCenter())
      })

      map.addListener('dragstart', function () {
        vm.$emit('onMapLoading', true)
      })
      //   map.addListener("dragend", function() {
      //     vm.markerposition.lat = vm.marker.getPosition().lat();
      //     vm.markerposition.lng = vm.marker.getPosition().lng();
      //     vm.infoloading = false;
      //   });

      map.addListener('idle', function () {
        vm.markerposition.lat = vm.marker.getPosition().lat()
        vm.markerposition.lng = vm.marker.getPosition().lng()
        try {
          vm.$emit('onMapLoading', false)
        } catch (error) {
          //
        }
      })

      preview_map.addListener('idle', function () {
        vm.preview_markerposition.lat = vm.preview_marker.getPosition().lat()
        vm.preview_markerposition.lng = vm.preview_marker.getPosition().lng()
        try {
          vm.$emit('onMapLoading', false)
        } catch (error) {
          //
        }
      })

      // eslint-disable-next-line no-undef
      vm.marker = new google.maps.Marker({ map })
      vm.setMarkerPosition(latlng, 'map')

      // eslint-disable-next-line no-undef
      vm.preview_marker = new google.maps.Marker({ map: preview_map })
      vm.setMarkerPosition(latlng, 'preview_map')

      preview_map.addListener('click', function () {
        vm.showMap = true
      })

      map.addListener('click', function (e) {
        if (!vm.marker) {
          // eslint-disable-next-line no-undef
          vm.marker = new google.maps.Marker({ map })
        }

        document.getElementById('map_clickable').focus()

        vm.setMarkerPosition(e.latLng, 'map')
      })

      if (vm.shoplocation && vm.shoplocation.length > 0) {
        vm.shoplocation.map((el) => {
          var location = null
          try {
            location = el.lat_long.split(',')
            if (location.length > 1) {
              // eslint-disable-next-line no-undef
              var shoplatlng = new google.maps.LatLng({
                lat: parseFloat(location[0]),
                lng: parseFloat(location[1])
              })

              if (vm.showRadius) {
                // eslint-disable-next-line no-undef
                new google.maps.Circle({
                  strokeColor: this.radiusColor,
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: this.radiusColor,
                  fillOpacity: 0.35,
                  map: map,
                  center: shoplatlng,
                  radius: this.radius // meters
                })
              }
              // eslint-disable-next-line no-undef
              new google.maps.Marker({
                position: shoplatlng,
                label: el.name,
                map: map
              })

              // eslint-disable-next-line no-undef
              new google.maps.Marker({
                position: shoplatlng,
                label: el.name,
                map: preview_map
              })
            }
          } catch (error) {
            //
          }
        })
      }
      vm.$emit('input', vm.markerposition)
      vm.$emit('onMapReady', vm.markerposition)
    },
    setCurrent() {
      var vm = this
      var options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
      if (!vm.haveGPS) {
        alert(
          'Please close and re-open this window in order to allow location permissions'
        )

        navigator.geolocation.getCurrentPosition(
          ({ coords }) => {
            vm.currentCoords.lat = coords.latitude
            vm.currentCoords.lng = coords.longitude

            vm.haveGPS = true
          },
          (err) => {
            vm.currentCoords.lat = vm.storelocation.lat
            vm.currentCoords.lng = vm.storelocation.lng

            vm.haveGPS = false

            // eslint-disable-next-line no-console
            console.warn(`ERROR(${err.code}): ${err.message}`)
          },
          options
        )
      } else {
        // eslint-disable-next-line no-undef
        var latlng = new google.maps.LatLng({
          lat: vm.currentCoords.lat,
          lng: vm.currentCoords.lng
        })
        if (!vm.marker) {
          // eslint-disable-next-line no-undef
          vm.marker = new google.maps.Marker({ map })
        }
        vm.setMarkerPosition(latlng, 'map')

        if (!vm.preview_marker) {
          // eslint-disable-next-line no-undef
          vm.preview_marker = new google.maps.Marker({ map: preview_map })
        }

        vm.setMarkerPosition(latlng, 'preview_map')
      }
    },
    confrimAddress() {
      this.showMap = false
      this.$emit('input', this.markerposition)
      this.$emit('select', this.markerposition)
      this.setMarkerPosition(this.markerposition, 'preview_map')
    },
    setMarkerPosition(latLng, type = 'map') {
      if (type == 'map') {
        if (!this.marker) {
          // eslint-disable-next-line no-undef
          this.marker = new google.maps.Marker({ map })
        }
        this.marker.setPosition(latLng)
        this.markerposition.lat = this.marker.getPosition().lat()
        this.markerposition.lng = this.marker.getPosition().lng()
        map.panTo(this.marker.getPosition())
      } else if (type == 'preview_map') {
        if (!this.preview_marker) {
          // eslint-disable-next-line no-undef
          this.preview_marker = new google.maps.Marker({ map: preview_map })
        }

        this.preview_marker.setPosition(latLng)
        this.preview_markerposition.lat = this.preview_marker
          .getPosition()
          .lat()
        this.preview_markerposition.lng = this.preview_marker
          .getPosition()
          .lng()
        preview_map.panTo(this.preview_marker.getPosition())
      }
    }
  },
  watch: {
    shippingType(newVal, oldVal) {
      if (newVal != oldVal && this.markerposition) {
        this.$emit('input', this.markerposition)
      }
    },
    shoplocation(newVal) {
      if (newVal && newVal.length > 0 && newVal[0].lat_long) {
        try {
          let lat_lng = newVal[0].lat_long.split(',')
          if (lat_lng.length == 2)
            this.storelocation = {
              lat: parseFloat(lat_lng[0]),
              lng: parseFloat(lat_lng[1])
            }
        } catch (error) {
          //
        }
      }
    }
    // markerposition: {
    //   deep: true,
    //   handler() {
    //     var vm = this;
    //     vm.$emit("input", vm.markerposition);
    //   },
    // },
  }
}
</script>

<style lang="scss">
.pac-container:after {
  /* Disclaimer: not needed to show 'powered by Google' if also a Google Map is shown */

  background-image: none !important;
  height: 0px;
}
.addressinfo {
  background-color: #505c77;
  min-height: 40px;
  bottom: 60%; /* position the top  edge of the element at the middle of the parent */
  left: 50%; /* position the left edge of the element at the middle of the parent */
  transform: translateX(-50%);
  position: absolute;
  word-break: break-word;
  color: white;
  padding: 7px;
  border-radius: 3px;
  font-size: 10px;
}
</style>
